/* Publish by EComposer at 2026-09-28 13:00:22*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vyroqmxacso"]=  window.__ectimmers["ecom-vyroqmxacso"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-vyroqmxacso').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vyroqmxacso', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ehxp0qi8c8j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ehxp0qi8c8j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lwp4hix3qyj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lwp4hix3qyj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-391z3e05yx8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-391z3e05yx8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0l60npdhmji').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0l60npdhmji', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-1evtr9m0q4z"]=  window.__ectimmers["ecom-1evtr9m0q4z"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-1evtr9m0q4z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1evtr9m0q4z', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0xvv64llxu8b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0xvv64llxu8b', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}